<template>
  <NextReviewerModal
    ref="modal"
    :asyncSelectOptions="getNextReviewerOptions"
    @onOkClick="save"
  >
    <template slot="add-text">
      <dl
        v-if="reviewHistories.length"
        class="tip"
      >
        <dt class="tip__text font-bold">
          {{ $t('tenantProjects.submission.prevReviewerList') }}:
        </dt>
        <dd>
          <ul>
            <li
              v-for="(item, index) in reviewHistories"
              :key="index"
              class="tip__text"
            >
              {{ $t('reviewedBy', [item.displayName, item.date]) }}
            </li>
          </ul>
        </dd>
      </dl>
    </template>
  </NextReviewerModal>
</template>

<script>
import { unref, computed } from 'vue-demi'
import { updateGreenFitoutSubmission } from '@/api/tenantProjects/greenFitout.request'
import NextReviewerModal from '@/controls/Modal/NextReviewerModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreGetters } from '@/store/index'
import { PermTypeMapKeys } from '@/utils/aclHelper'
import dateUtil from '@/utils/dateUtil'
import { getUsersForSameBuilding } from '../utils'
import { useCurrentGreenFitout, useRefreshCurrentGreenFitout, useGreenFitoutReviewers } from './hook'
import { GREEN_FITOUT_HISTORY_ACTION_TYPE, GREEN_FITOUT_HISTORY_TYPE, GREEN_FITOUT_STATUS } from './consts'
import { buildGreenFitOutHistory } from './utils'

/**
 * @type {import('vue').ComponentOptions}
 */
export default {
  components: {
    NextReviewerModal,
  },
  setup () {
    const { open, modal } = useRefModal()
    const { currentTenantProject } = useStoreGetters('tenantProject', ['currentTenantProject'])
    const currentGreenFitout = useCurrentGreenFitout()
    const refresh = useRefreshCurrentGreenFitout()
    const reviewers = useGreenFitoutReviewers()
    const reviewHistories = computed(() => {
      return unref(reviewers).map(item => ({
        displayName: item.displayName,
        date: dateUtil.format(item.createdAt, dateUtil.DD_MMM_YY_HH_MM),
      }))
    })
    return {
      open,
      modal,
      reviewHistories,
      getNextReviewerOptions: async () => {
        const managedBy = unref(currentGreenFitout).managedBy
        const result = await getUsersForSameBuilding(
          unref(currentTenantProject).tenancy,
          PermTypeMapKeys.GREEN_FIT_OUT_NEXT_REVIEWER,
          { id: managedBy },
          { includeTrReps: true },
        )
        return result.map(item => ({ name: item.displayPicName, value: { id: item.id, username: item.username, email: item.email } }))
      },
      save: async () => {
        const newReviewer = JSON.parse(unref(modal).getSelectedValue())
        const addHistoryList = [buildGreenFitOutHistory(
          GREEN_FITOUT_HISTORY_TYPE.SUBMISSION,
          GREEN_FITOUT_HISTORY_ACTION_TYPE.NEXT_REVIEWER,
        )]
        await updateGreenFitoutSubmission(unref(currentGreenFitout).id, {
          managedBy: newReviewer.id,
          status: GREEN_FITOUT_STATUS.UNDER_REVIEW,
          addHistoryList,
          lock: unref(currentGreenFitout).lock,
        })
        await refresh()
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.tip {
  margin-top: 10px;
  dt {
    margin-bottom: 0;
  }
}
li.tip__text {
  list-style: decimal;
}
</style>
